import React from 'react';
import { Card, CardContent, Box, Typography, Link as MuiLink } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from './MeterDetailsSummaryCard.styles';
import { useNavWithTrail } from '../../../../layouts/TrailProvider';
import { coerceFaulty } from '../../utils/meter.helpers';

export default function MeterDetailsSummaryCard({ meterData, dash, fmtDT, getMeterTypeName }) {
  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const items = [
    ['Operator', meterData?.OperatorDescription || meterData?.OperatorCode],
    ['Unit (Train)', meterData?.Unit, false, meterData?.Unit ? `/home/units/${encodeURIComponent(meterData.Unit)}` : null],
    ['EVN', meterData?.EVN, false, meterData?.EVN ? `/home/evns/${encodeURIComponent(meterData.EVN)}` : null],
    ['Meter Type', meterData?.MeterType != null ? getMeterTypeName(meterData.MeterType) : '—'],
    ['Effective from', meterData?.FromDate, true],
    ['Effective to', meterData?.ToDate, true],
    ['Creation Date', meterData?.CreationDate, true],
    ['Faulty', coerceFaulty(meterData?.Faulty).toString().toUpperCase()],
  ];

  const navigateTo = (link) => {
    if (link) nav(link);
  };

  return (
    <Card sx={styles.summaryCard}>
      <CardContent sx={styles.summaryCardContent}>
        <Box sx={styles.contentRow}>
          {items.map(([label, value, isDate, link]) => (
            <Box key={label} sx={styles.item}>
              <Box sx={styles.textBox}>
                <Typography sx={styles.label}>{label}</Typography>
                {link ? (
                  value ? (
                    <MuiLink
                      underline="none"
                      sx={styles.link}
                      onClick={() => navigateTo(link)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          navigateTo(link);
                        }
                      }}
                      role="link"
                      tabIndex={0}
                      aria-label={`Go to ${value}`}
                    >
                      {dash(value)}
                    </MuiLink>
                  ) : (
                    <Typography sx={styles.value}>—</Typography>
                  )
                ) : (
                  <Typography sx={styles.value}>
                    {isDate ? fmtDT(value) : dash(value)}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
